import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PROFILEIMAGE from "../assets/ProfilePicture.png";

import Footer from "../Components/Footer";
import LISTINGSIMAGE from "../assets/ListingsImage.jpg";
import APPOINTMENTDEFAULTIMAGE from "../assets/Appointments.png";
import { source } from "../Constants/source";
import PropTypes from "prop-types";
import ListingsCard from "../Components/ListingsCard";
import CustomCarousel from "./Carousel/CustomCarousel";
// import PDFDisplay from "../Components/PdfViewer";
import listingSource from "../Constants/listingSource";
import { hiddenCategories } from "../Constants/hiddenCategories";
import HomePageNavBar from "../Components/HomePageNavBar";

import { getPreferredListings, getListingsById } from "../Services/listingsApi";
import { getCategory } from "../Services/CategoryApi";
import {
  getFavorites,
  postFavoriteListingsData,
  deleteListingsById,
} from "../Services/favoritesApi";
import { ClipLoader } from "react-spinners";
import mediaType from "../Constants/mediaType.js";

function ListingDetailSkeleton() {
  return (
    <div className="animate-pulse">
      {/* NavBar Placeholder */}
      <div className="w-full h-16 bg-gray-100"></div>

      {/* Content Container */}
      <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-20 flex flex-col items-center gap-2">

        {/* Title and Avatar */}
        <div className="w-full flex items-center gap-4">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gray-200 rounded-full"></div>
          <div className="h-6 bg-gray-200 rounded w-1/3"></div>
        </div>

        {/* Media Preview */}
        <div className="w-full flex justify-center my-4">
          <div className="w-full h-80 bg-gray-200 rounded-lg"></div>
        </div>

        {/* Description */}
        <div className="w-full space-y-3 mb-6">
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3"></div>
        </div>

        {/* Category + Favorite */}
        <div className="w-full flex items-center gap-2 mt-2">
          <div className="h-6 bg-gray-200 rounded-full w-24"></div>
          <div className="h-8 w-8 bg-gray-200 rounded-full"></div>
        </div>
      </div>

      {/* Similar Items */}
      <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-10 flex flex-col space-y-6">
        <div className="h-6 bg-gray-200 rounded w-48"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="h-60 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="w-full h-20 bg-gray-100"></div>
    </div>
  );
}

const Description = (props) => {
  const [desc, setDesc] = useState();
  function convertAndLinkify(input) {
    const container = document.createElement("div");
    container.innerHTML = input;

    function processElement(element) {
      if (element.nodeName === "OL") {
        return Array.from(element.children)
          .map((child, index) => `${index + 1}. ${processElement(child)}`)
          .join("\n");
      } else if (element.nodeName === "UL") {
        return Array.from(element.children)
          .map((child) => `\u2022  ${processElement(child)}`)
          .join("\n");
      } else if (element.nodeName === "LI") {
        return element.textContent.trim();
      } else if (element.nodeName === "BR") {
        return "\n";
      } else if (element.nodeName === "STRONG") {
        const strongText = Array.from(element.childNodes)
          .map((child) => processElement(child))
          .join("");
        return `<b>${strongText}</b>`;
      } else if (element.nodeName === "I" || element.nodeName === "EM") {
        const italicText = Array.from(element.childNodes)
          .map((child) => processElement(child))
          .join("");
        return `<i>${italicText}</i>`;
      } else if (element.nodeName === "U" ||
        (element.nodeName === "SPAN" && element.style.textDecoration.includes("underline"))) {
        const underlineText = Array.from(element.childNodes)
          .map((child) => processElement(child))
          .join("");
        return `<u>${underlineText}</u>`;
      } else {
        return element.textContent.trim();
      }
    }

    const plainText = Array.from(container.childNodes)
      .map((node) => processElement(node))
      .filter((text) => text.trim() !== "")
      .join("\n");

    const htmlText = plainText.replace(/\n/g, "<br>");
    return linkify(htmlText);
  }

  const linkify = (text) => {
    const urlRegex =
      /(?<!<img\s[^>]*)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])(?![^<]*<\/a>)/gi;

    text = text.replace(
      urlRegex,
      (url) =>
        `<a class="underline" href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );

    const anchorTagRegex = /<a\s+href="([^"]+)"(.*?)>(.*?)<\/a>/gi;

    return text.replace(anchorTagRegex, (match, url, attributes, linkText) => {
      if (!/class="[^"]*underline[^"]*"/.test(attributes)) {
        if (/class="/.test(attributes)) {
          return `<a href="${url}" ${attributes.replace(
            /class="/,
            'class="underline '
          )}>${linkText}</a>`;
        } else {
          return `<a href="${url}" class="underline" ${attributes}>${linkText}</a>`;
        }
      }
      return match;
    });
  };

  useEffect(() => {
    const linkedContent = convertAndLinkify(props.content);
    setDesc(linkedContent);
  }, [props.cityId, props.content]);

  return (
    <div
      className="leading-relaxed text-md font-medium my-6 text-slate-800 dark:text-slate-800"
      dangerouslySetInnerHTML={{ __html: desc }}
    ></div>
  );
};

Description.propTypes = {
  content: PropTypes.string.isRequired,
  cityId: PropTypes.string,
};

Description.defaultProps = {
  cityId: null, // or some default value
};

const Listing = () => {
  window.scrollTo(0, 0);
  const { t } = useTranslation();
  const [profileImageLoaded, setProfileImageLoaded] = useState(false);
  const [listingId, setListingId] = useState(0);
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [sourceId, setSourceId] = useState("");
  const [website, setWebsite] = useState("");
  const [user, setUser] = useState();
  const [userId, setUserId] = useState();
  const [listings, setListings] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [favoriteId, setFavoriteId] = useState(0);
  const [cityId, setCityId] = useState(0);
  const [terminalView, setTerminalView] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const queryParams = new URLSearchParams(location.search);
  const terminalViewParam = queryParams.get("terminalView");

  const isTerminalScreenEnvEnabled =
    process.env.REACT_APP_ENABLE_TERMINALSCREEN === "True";

  const isTerminalScreenEnabled = isTerminalScreenEnvEnabled && terminalViewParam === "true";

  const [input, setInput] = useState({
    categoryId: 0,
    subcategoryId: 0,
    userId: 2,
    title: "",
    place: "",
    phone: "",
    email: "",
    description: "",
    media: [],
    startDate: "",
    endDate: "",
    originalPrice: "",
    villagedropdown: "",
    zipcode: "",
    discountedPrice: "",
    appointmentId: null, // If used in your logic
    sourceId: null, // To ensure sourceId is accessible directly
  });

  const navigate = useNavigate();
  const navigateTo = (path) => {
    if (path) {
      navigate(path);
    }
  };

  useEffect(() => {
    document.title = process.env.REACT_APP_REGION_NAME + " " + t("eventDetails");
    setTerminalView(isTerminalScreenEnabled);

    getCategory().then((response) => {
      const catList = {};
      response?.data?.data
        .filter((cat) => !hiddenCategories.includes(cat.id))
        .forEach((cat) => {
          catList[cat.id] = cat.name;
        });
      setCategories(catList);
    });
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setIsLoading(true);
    const listingId = searchParams.get("listingId");

    if (listingId) {
      const accessToken =
        window.localStorage.getItem("accessToken") ||
        window.sessionStorage.getItem("accessToken");
      const refreshToken =
        window.localStorage.getItem("refreshToken") ||
        window.sessionStorage.getItem("refreshToken");
      const isLoggedIn = accessToken || refreshToken;
      setIsLoggedIn(isLoggedIn);

      let isListingLoaded = false;
      let isPreferredListingsLoaded = false;

      const checkLoadingState = () => {
        if (isListingLoaded && isPreferredListingsLoaded) {
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        }
      };

      getListingsById(listingId)
        .then((listingsResponse) => {
          if (
            listingsResponse.data.data.sourceId !== source.User &&
            listingsResponse.data.data.showExternal !== 0
          ) {
            window.location.replace(listingsResponse.data.data.website);
            return;
          }

          setInput({
            ...listingsResponse.data.data,
            media: listingsResponse.data.data.media || [],
          });
          setCityId(listingsResponse.data.data.cityId);
          setUser(listingsResponse.data.data.userData);
          setUserId(listingsResponse.data.data.userData.id);
          setSelectedCategoryId(listingsResponse.data.data.categoryId);
          setListingId(listingsResponse.data.data.id);
          setDescription(listingsResponse.data.data.description);
          setTitle(listingsResponse.data.data.title);
          setSourceId(listingsResponse.data.data.sourceData.id);
          setWebsite(listingsResponse.data.data.website);

          const fetchFavorites = async () => {
            try {
              const userId = localStorage.getItem("userId");
              const response = await getFavorites(userId);
              const favorites = response?.data?.data?.[0]?.data || [];

              const isFavorite = favorites.find((fav) => fav.id === parseInt(listingId));
              if (isFavorite) {
                setFavoriteId(isFavorite.id);
              }
            } catch (error) {
              console.error("Error fetching favorites", error);
            }
          };

          fetchFavorites();

          isListingLoaded = true;
          checkLoadingState();
        })
        .catch((error) => {
          console.error("Error fetching listing:", error);
          navigateTo("/Error");
        });

      const fetchPreferredListings = async (userId) => {
        try {
          if (!userId) {
            console.error("User ID is missing, skipping fetch.");
            return;
          }
          const response = await getPreferredListings(userId);
          const data = response.data.data;
          setListings(data);
        } catch (error) {
          console.error("Error fetching listings:", error);
        } finally {
          isPreferredListingsLoaded = true;
          checkLoadingState();
        }
      };

      setTimeout(() => {
        const userId = window.localStorage.getItem("userId");
        if (userId) {
          fetchPreferredListings(userId);
        } else {
          isPreferredListingsLoaded = true; // Mark it as loaded even if no userId
          checkLoadingState();
        }
      }, 1000);
    }
  }, [t, cityId, window.location.href, isLoggedIn]);

  useEffect(() => {
    const userId = window.localStorage.getItem("userId");
    if (selectedCategoryId && userId) {
      getPreferredListings(userId, { categoryId: selectedCategoryId })
        .then((response) => {
          const filteredListings = response.data.data.filter(
            (listing) => listing.id !== listingId
          );
          setListings(filteredListings);
        })
        .catch((error) => {
          console.error("Error fetching preferred listings:", error);
        });
    }
  }, [selectedCategoryId, listingId]);

  const handleFavorite = async () => {
    try {
      if (!isLoggedIn) {
        window.sessionStorage.setItem("redirectTo", "/Favorite");
        return navigateTo("/login");
      }

      const userId = localStorage.getItem("userId");
      if (!userId || !listingId) {
        console.error("Missing userId or listingId");
        return;
      }

      if (favoriteId !== 0) {
        // DELETE favorite
        await deleteListingsById(userId, listingId);
        setFavoriteId(0);
      } else {
        // POST favorite
        const response = await postFavoriteListingsData({ listingId });
        const newId = response?.data?.data?.id;
        setFavoriteId(newId);
      }
    } catch (error) {
      console.error("Favorite toggle failed", error);
    }
  };

  useEffect(() => {
    if (user && listings.length > 0) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [user, listings]);

  function goBack() {
    navigateTo(`/`);
  }

  const validMedia = (input.media || []).filter((item) => item.signedUrl !== null);
  const pdfMedia = validMedia.find((item) => item.mediaType === mediaType.PDF);
  const carouselMedia = validMedia.filter((item) => item.mediaType === mediaType.IMAGE);
  return (
    <section className="text-slate-800 bg-white body-font">
      {isLoading ? (
        <ListingDetailSkeleton />
      ) : (
        <div>
          <HomePageNavBar  showBlackLogo/>

          <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-20 flex flex-col items-center gap-2">
            {/* Title and Favorite Button */}
            <div className="w-full flex items-center gap-4">
              <div className="relative w-12 h-12 sm:w-14 sm:h-14">
                {!profileImageLoaded && (
                  <div className="absolute inset-0 flex items-center justify-center bg-gray-200 rounded-full animate-pulse">
                    <ClipLoader size={24} color="#36D7B7" />
                  </div>
                )}
                <img
                  onClick={() => navigateTo(`/ViewProfile/${userId}`)}
                  src={user?.image || PROFILEIMAGE}
                  alt={user?.name || "User"}
                  onLoad={() => setProfileImageLoaded(true)}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = PROFILEIMAGE;
                    setProfileImageLoaded(true);
                  }}
                  className={`rounded-full cursor-pointer object-cover w-full h-full transition-opacity duration-300 ${profileImageLoaded ? "opacity-100" : "opacity-0"}`}
                />
              </div>

              <h1 className="text-slate-800 text-2xl sm:text-3xl font-bold font-['Space Grotesk', Helvetica, Arial, Lucida, sans-serif]">
                {title}
              </h1>
            </div>

            {/* Image or PDF */}
            <div className="w-full flex justify-center mb-6 mt-2">
              {validMedia.length > 0 ? (
                <div className="w-full">
                  {pdfMedia ? (
                    <iframe
                      src={pdfMedia.signedUrl}
                      width="100%"
                      height="500px"
                      className="rounded-lg shadow-md"
                      title="PDF Viewer"
                    ></iframe>
                  ) : carouselMedia.length > 0 ? (
                    <CustomCarousel
                      imageList={carouselMedia}
                      sourceId={input.sourceId}
                      appointmentId={input.appointmentId || null}
                    />
                  ) : null}
                </div>
              ) : (
                <img
                  alt="default"
                  className="object-cover object-center rounded-lg shadow-md w-full max-h-[500px]"
                  src={input.appointmentId !== null ? APPOINTMENTDEFAULTIMAGE : LISTINGSIMAGE}
                />
              )}
            </div>

            {/* Description */}
            <div className="w-full text-start text-lg text-gray-700 mb-6 leading-relaxed">
              <Description content={description} cityId={cityId} />
              {(sourceId === listingSource.SCRAPER || sourceId === listingSource.INSTAGRAM) && (
                <p className="text-slate-800 font-medium mt-2">
                  {t("visitWebsite")} <a href={website} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">{website}</a>
                </p>
              )}
            </div>

            {/* Category */}
            <div className="w-full flex items-center gap-2 mt-2">
              <p className="bg-gray-200 text-gray-800 px-4 py-2 rounded-full text-sm font-semibold">
                {categories[input.categoryId] ? categories[input.categoryId] : t("category")}
              </p>

              <button
                onClick={handleFavorite}
                className="relative inline-flex items-center justify-center px-4 py-2 rounded-full bg-gray-200 cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="w-5 h-5"
                  fill={favoriteId !== 0 ? "red" : "black"}
                >
                  <path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" />
                </svg>
              </button>
            </div>
          </div>

          <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-10 space-y-10 flex flex-col">
            <h1 className="text-lg font-bold leading-tight tracking-tight text-slate-800 md:text-2xl dark:text-slate-800">
              {t("similarItems")}
            </h1>
            {listings && listings.length > 0 ? (
              <div className="relative place-items-center bg-white mb-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 justify-start">
                {listings &&
                  listings
                    .filter(
                      (listing) =>
                        listing.id !== listingId
                    )
                    .map((listing, index) => (
                      <ListingsCard
                        listing={listing}
                        terminalView={terminalView}
                        key={index}
                      />
                    ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center min-h-[40vh] px-6">
                <h2 className="mb-6 text-4xl font-bold">
                  {t("currently_no_listings")}
                </h2>
                <p className="text-lg text-gray-600">
                  {t("selectOtherCityorCategory")}
                </p>
                <button
                  onClick={goBack}
                  className="mt-10 px-6 py-3 bg-gray-700 text-white rounded-full hover:scale-105 transition"
                >
                  {t("goBack")}
                </button>
              </div>
            )}
          </div>

          {!isLoading && !terminalView && (
            <div className="bottom-0 w-full">
              <Footer />
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default Listing;